type SheetShape = { readonly fields: readonly unknown[] };

/** A sheet title is required as soon as the sheet counts one field, archived ones included. */
function isSheetTitleValid<T extends SheetShape>(value: string, formData: T): boolean {
	return formData.fields.length === 0 || value.trim().length > 0;
}

export default isSheetTitleValid;
